import { Positions } from "model/Positions";
import { Scores } from "model/Scores";
import { getForwardCupModeRoundResultDisplayScore } from "./CupModeRoundResult";
import { CupModeTrack } from "./CupModeTrack";

export type CupModeLongTrack = CupModeTrack & {
  finalPositions: Positions | undefined;
  scores: Scores;
};

export const getForwardCupModeLongTrackRosterDisplayScore = (
  track: CupModeLongTrack,
  teamId: string,
  finalist: boolean,
  pointsLimit: number
) => {
  const score = track.scores[teamId];
  if (score === undefined) {
    return undefined;
  }

  return getForwardCupModeRoundResultDisplayScore(score, finalist, pointsLimit);
};
